const comments = [
  {
    name: '影迷小王',
    text: '用了豆花视频半年多了，资源真的很全，更新也快。之前在其他平台找不到的悬疑剧这里都有，画质清晰播放流畅，推荐给身边好多人了。',
    time: '3天前',
    platform: '来自网页端',
  },
  {
    name: '追剧达人Lucy',
    text: '最喜欢豆花视频的专题合集功能，每次想刷剧直接看编辑精选就行，省去找片的麻烦。古装剧和甜宠剧的推荐都很对我胃口！',
    time: '5天前',
    platform: '来自手机端',
  },
  {
    name: '老张看电影',
    text: '免费的观影平台能做到这个程度真的很良心了，纪录片资源也很丰富。不卡顿这点特别赞，晚上高峰时段也很流畅。',
    time: '1周前',
    platform: '来自网页端',
  },
  {
    name: '动漫迷小陈',
    text: '国漫资源很全！灵笼、凡人修仙传这些都有，更新也及时。不用注册就能看这点太方便了，安利给所有二次元朋友。',
    time: '1周前',
    platform: '来自手机端',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          用户评价
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">听听豆花视频用户怎么说</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="rounded-xl p-5 bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-sm font-heading font-bold">
                  {comment.name.charAt(0)}
                </div>
                <div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900">{comment.name}</h3>
                  <p className="text-[10px] text-foreground-500 font-label">{comment.platform}</p>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed font-body mb-3 line-clamp-4">
                "{comment.text}"
              </p>
              <p className="text-[10px] text-foreground-400 font-label">{comment.time}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}